export interface ShouldShowOlderVersionMessageParams {
  evaluatorType: string;
  evaluatorVersion: number;
  commitHash: string | null;
  latestCommitHash: string | undefined | null;
}

export function shouldShowOlderVersionMessage(
  params: ShouldShowOlderVersionMessageParams
): boolean {
  return (
    params.evaluatorType === 'hub' &&
    params.evaluatorVersion >= 3 &&
    !!params.commitHash &&
    params.commitHash !== 'latest' &&
    params.commitHash.slice(0, 8) !== params.latestCommitHash?.slice(0, 8)
  );
}
